import React from 'react';
import { Message, useMessage } from '@messageformat/react';
import { Button, Tile } from '@op/opds.opux';
import './CardTile.scss';
import formatPriceWithText from '../../util/commonUtil';
import { sendAdobeAnalyticsActionData } from '../../util/analytics';
import { analyticsPhases } from './CardSelectorTool';

interface CardTileProps {
  imageUrl: string;
  title: string;
  descriptionText: string;
  ownerCustomerPrice: string;
  normalPrice?: string;
  buttonHref: string;
  primaryRecommendation: boolean;
  tileNumber: number;
  duo?: boolean;
  showCampaignRibbon?: boolean;
}

const CardTile = (props: CardTileProps) => {
  const normalPriceText = useMessage('paketinvalintatyokalu:tiili:yhteiset:muuthinta', '');
  const buttonText = useMessage(
    props.duo ? 'paketinvalintatyokalu:tiili:yhteiset:twocards:button' : 'paketinvalintatyokalu:tiili:yhteiset:onecard:button',
    '',
  );
  const icmpAnalyticsParameter = props.primaryRecommendation ? '?icmp=sv-na-korttiapuri_suositus1' : '?icmp=sv-na-korttiapuri_suositus2';
  const href = props.buttonHref + icmpAnalyticsParameter;

  let styleClasses = 'card-tile';
  if (props.primaryRecommendation) styleClasses += ' card-tile-scale-primary';
  if (!props.primaryRecommendation) styleClasses += ' card-tile-scale';
  if (props.tileNumber === 2) styleClasses += ' card-tile-middle';

  let dataTestId;
  if (props.tileNumber === 1) dataTestId = 'recommendation-left';
  else if (props.tileNumber === 2) dataTestId = 'recommendation-middle';
  else if (props.tileNumber === 3) dataTestId = 'recommendation-right';

  return (
    <Tile className={styleClasses} data-testid={dataTestId}>
      <div className="card-tile-image-container">
        <img alt={props.title} src={props.imageUrl} className="card-tile-image" />
      </div>
      <h4 className="card-tile-h4">{props.title}</h4>
      {props.showCampaignRibbon && (
        <span className="pac-tile-campaign-tag" data-testid="campaign-ribbon">
          <Message id="yleiset:hintaetu" />
        </span>
      )}
      <p className="card-tile-description">{props.descriptionText}</p>
      <div className="card-tile-prices-container">
        <div className="card-tile-ownercustomer-price">
          {formatPriceWithText(useMessage('paketinvalintatyokalu:tiili:yhteiset:omistajaasiakashinta', ''), props.ownerCustomerPrice)}
        </div>
        {props.normalPrice && <div className="card-tile-normal-price">{formatPriceWithText(normalPriceText, props.normalPrice)}</div>}
      </div>
      <div className="card-tile-button-container">
        <Button
          primary
          className="card-tile-button"
          data-testid="button"
          href={href}
          tabIndex={0}
          onClick={() =>
            sendAdobeAnalyticsActionData(
              props.primaryRecommendation ? 'Ensisijainen suositus' : 'Toissijainen suositus',
              'click',
              analyticsPhases.get('result')!,
            )
          }
          aria-label={buttonText + ' – ' + props.title}
        >
          {buttonText}
        </Button>
      </div>
    </Tile>
  );
};

export default CardTile;
